import React, { useContext, useState } from "react";
import {
  Box,
  Breadcrumbs,
  Typography,
  Button,
  Divider,
} from "@mui/material";
import Notification from "../../../components/Notification";
import Notificationicon from "../../../assets/svg/notifications.svg";
import help from "../../../assets/svg/help.svg";
import SidebarContext from "../../../context/SidebarContext";
import { Link, useNavigate } from "react-router-dom";

// import your stepper
import Sender from "./Sender";
import Receiver from "./Receiver";
import Package from "./Package";
import Shipping from "./Shipping";
import StepperForm from "./Stepper";

const steps = [
  { label: "Sender" },
  { label: "Receiver" },
  { label: "Package" },
  { label: "Shipping" },
];

function NewQuote() {
  const navigation = useNavigate();
  const { open } = useContext(SidebarContext);
  const [notificationDrawerOpen, setNotificationDrawerOpen] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  console.log('activeStep: ', activeStep);

  const toggleNotification = () => {
    setNotificationDrawerOpen(!notificationDrawerOpen);
  };

  const breadcrumbs = [
    <Link
      key="1"
      to="/"
      style={{ color: "#1C2630", fontWeight: 500, fontSize: "12px" }}
    >
      Home
    </Link>,
    <Link
      key="2"
      to="/shipping/route-partner"
      style={{ color: "#1C2630", fontWeight: 500, fontSize: "12px" }}
    >
      Shipping Service
    </Link>,
    <Typography
      key="3"
      sx={{ color: "#959BA1", fontWeight: 500, fontSize: "12px" }}
    >
      Get Shipping Quote
    </Typography>,
  ];

  const renderStepContent = () => {
    switch (activeStep) {
      case 0:
        return <Sender />;
      case 1:
        return <Receiver />;
      case 2:
        return <Package />;
      case 3:
        return <Shipping />;
      default:
        return null;
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: { xs: "auto", sm: "96vh" },
        minHeight: { xs: "100vh", sm: "96vh" },
        overflowY: "auto",
        margin: { xs: "10px", sm: "15px", md: "20px" },
        marginRight: { xs: "10px", sm: "15px", md: "0px" },
        width: {
          xs: "calc(100vw - 20px)",
          sm: open === true ? "calc(98vw - 240px)" : "calc(98vw - 80px)",
        },
        backgroundColor: "#FFF",
        padding: { xs: "15px", sm: "20px" },
        borderRadius: "12px",
      }}
    >
      {/* Header */}
      <Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            alignItems: { xs: "flex-start", sm: "center" },
            justifyContent: "space-between",
            borderBottom: "1px solid #E5E5E8",
            paddingBottom: "8px",
            gap: { xs: 2, sm: 0 },
          }}
        >
          <Box sx={{ width: { xs: "100%", sm: "auto" } }}>
            <Typography
              sx={{
                fontSize: { xs: "20px", sm: "24px", md: "26px" },
                fontWeight: "bold",
              }}
            >
              Get Shipping Quote
            </Typography>
            <Breadcrumbs
              separator="›"
              aria-label="breadcrumb"
              sx={{
                "& .MuiBreadcrumbs-ol": {
                  flexWrap: { xs: "wrap", sm: "nowrap" },
                },
              }}
            >
              {breadcrumbs}
            </Breadcrumbs>
          </Box>

          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: { xs: "flex-start", sm: "flex-end" },
              gap: { xs: 1, sm: 0 },
            }}
          >
            <Box
              sx={{
                marginRight: { xs: "10px", sm: "20px" },
                cursor: "pointer",
              }}
              onClick={toggleNotification}
            >
              <img src={Notificationicon} alt="notification_icon" />
            </Box>
            <Notification
              open={notificationDrawerOpen}
              onClose={toggleNotification}
            />
            <Box>
              <img src={help} alt="help_icon" />
            </Box>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          marginTop: "20px",
          marginBottom: "20px",
          width: "100%",
          maxWidth: "800px",
          display: "flex",
          alignSelf: "center",
        }}
      >
        <StepperForm steps={steps} activeStep={activeStep} />
      </Box>

      <Divider />

      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "800px",
          }}
        >
          <Box sx={{ marginTop: "32px" }}>{renderStepContent()}</Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column-reverse", sm: "row" },
              justifyContent: { xs: "center", sm: "flex-end" },
              marginTop: "20px",
              gap: "10px",
            }}
          >
            <Button
              variant="outlined"
              onClick={() => setActiveStep((prev) => Math.max(prev - 1, 0))}
              disabled={activeStep === 0}
              sx={{
                width: { xs: "100%", sm: "155px" },
                color: "black",
                border: "1px solid #E5E5E8",
                borderRadius: "4px",
                boxShadow: "none",
                whiteSpace: "nowrap",
                fontWeight: 600,
                marginTop: { xs: "0", sm: "20px" },
              }}
            >
              Cancle
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                if (activeStep === 3) {
                    navigation("/shipping/get-shipping-quote/result");
                } else {
                  setActiveStep((prev) => Math.min(prev + 1, steps.length - 1));
                }
              }}
              sx={{
                backgroundColor: "#5E17EB",
                width: { xs: "100%", sm: "155px" },
                color: "#fff",
                border: "1px solid #5E17EB",
                borderRadius: "4px",
                boxShadow: "none",
                whiteSpace: "nowrap",
                fontWeight: 600,
                marginTop: { xs: "0", sm: "20px" },
                "&:hover": {
                  outline: "none",
                  color: "#fff",
                  backgroundColor: "#5E17EB",
                },
              }}
            >
              {activeStep === steps.length - 1 ? "Submit" : "Continue"}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}

export default NewQuote;
